<template>
  <el-dropdown class="hover-effect" trigger="click" placement="bottom-start">
    <!-- 消息图标 + 未读角标 -->
    <el-badge :value="unreadCount" type="danger" :hidden="unreadCount === 0">
      <i class="el-icon-message" style="font-size: 25px;opacity:.8;cursor: pointer;"></i>
    </el-badge>

    <!-- 下拉消息列表：外层容器固定宽度，内部拆分滚动区域 -->
    <el-dropdown-menu slot="dropdown" style="width: 350px;max-height: 300px;overflow: hidden;padding: 0;">
      <!-- 1. 站内消息标题栏：固定置顶 -->
      <div class="message-header-fixed" style="font-size: 14px;padding: 15px;border-bottom: 1px solid #ebeef5;display:flex;align-items: center;justify-content: space-between">
        <strong><span>站内消息</span></strong>
      </div>

      <!-- 2. 消息列表滚动容器：仅这部分滚动，高度自适应 -->
      <div class="message-list-scroll" style="max-height: calc(300px - 82px);overflow-y: auto;">
        <!-- 空消息提示 -->
        <div v-if="messageList.length === 0" style="padding: 20px;text-align: center;color: #909399;">
          暂无新消息
        </div>

        <!-- 消息列表 -->
        <el-dropdown-item
          v-for="item in messageList"
          :key="item.id"
          :command="item.id"
          style="padding: 0;margin: 0;border: none;"
        >
          <div class="message-item" :class="{ 'unread-item': !item.readStatus }" @click.stop="toMessageDetail(item)" style="background-color: white;">
            <div class="message-content">
              <div class="message-header">
                <span class="title">{{ item.title.length > 20 ? item.title.slice(0, 20) + '..' : item.title }}</span>
              </div>
              <div class="message-time">{{ item.createTime }}</div>
            </div>
            <!-- 未读红点标记 -->
            <div class="unread-dot" v-if="!item.readStatus"></div>
          </div>
        </el-dropdown-item>
      </div>

      <!-- 3. 查看全部按钮栏：固定置底 -->
      <div class="message-footer-fixed" style="display: flex;align-items: center;justify-content: center;line-height: 10px;padding: 10px 0;border-top: 1px solid #ebeef5;">
        <el-button type="text" size="small" @click="toMessageList">查看全部</el-button>
      </div>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
// 原有script逻辑完全保留，无需修改
import { top10, getUnreadCount} from '@/axios/sysAnnouncement/myAnnouncementList';

export default {
  name: 'MessageIcon',
  data() {
    return {
      messageList: [],
      unreadCount: 0
    }
  },
  watch: {
    messageList(newVal, oldVal){
      if (newVal.length > 0) {
        const firstItem = newVal[0]
        console.log('firstItem.readStatus:',firstItem.readStatus)
        console.log('firstItem.isPopup:',firstItem.isPopup)
        if(firstItem.readStatus === 0 && firstItem.isPopup === 1) {
          this.$emit('newMessage',firstItem.id)
        }
      }
    }
  },
  methods: {
    async getMessageList() {
      const res = await top10()
      if (res.errorCode === 0) {
        if(res.data.length > 0) {
          const mlist = []
          for (let item of res.data) {
            let obj = {}
            obj.id = item.id
            obj.title = item.title
            obj.type = item.typeCategory
            obj.typeName = item.typeName
            obj.readStatus = item.isRead
            obj.isPopup = item.isPopup
            obj.createTime = item.createTime
            mlist.push(obj)
          }
          this.messageList = mlist
        }else {
          this.messageList = []
        }
      }
    },
    async loadUnreadCount() {
      const res = await getUnreadCount()
      if (res.errorCode === 0) {
        const totalCount = res.data.totalCount;
        const readCount = res.data.readCount;
        this.unreadCount = totalCount - readCount
      }else {
        this.unreadCount = 0
      }
    },
    toMessageList() {
      const currentPath = this.$route.path
      const toPath = '/my_announcement_list'
      if (currentPath !== toPath) {
        this.$router.push(toPath)
      }
    },
    toMessageDetail(item) {
      this.messageList.filter(msg => msg.id === item.id)[0].readStatus = true
      const currentPath = this.$route.path
      const currentId = this.$route.query.id
      const toPath = '/my_announcement_detail'
      if (currentPath !== toPath || currentId !== item.id.toString()) {
        this.$router.push({path: toPath,query: { id: item.id }})
      }
    },
    async loadPage(){
      await this.getMessageList()
      await this.loadUnreadCount()
    }
  },
  created() {},
  mounted() {
    this.loadPage()
  }
}
</script>

<style scoped>
/* 基础消息项样式 */
.message-item {
  font-size: 13px;
  padding: 5px 15px;
  cursor: pointer;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #f5f7fa;
  transition: all 0.2s;
}
/* 已读消息样式 */
.message-item {
  background-color: #ffffff;
  color: #606266;
}
/* 未读消息样式（核心优化） */
.message-item.unread-item {
  background-color: #fff8f8;
  color: #303133;
}
.message-item.unread-item .title {
  font-weight: 600; /* 未读标题加粗 */
}
/* 未读红点标记 */
.unread-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #f56c6c;
  margin-right: 8px;
  flex-shrink: 0;
}
/* 消息内容容器 */
.message-content {
  flex: 1;
  overflow: hidden;
}
/* 消息头部 */
.message-header {
  display: flex;
  align-items: center;
  line-height: 1.4;
}
/* 标题样式 */
.title {
  margin-left: 5px;
  line-height: 25px;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/* 鼠标悬浮效果 */
.message-item:hover {
  background-color: #f5f7fa !important; /* 覆盖已读/未读背景 */
  color: #3d95ed;
}
.message-item .message-time{
  line-height: 15px;
  margin-left: 5px;
  font-size: 12px;
  color: #909399;
}

/* 关键修改：固定标题和底部按钮，优化滚动容器 */
/* 1. 标题栏固定 - 样式强化 */
.message-header-fixed {
  position: sticky;
  top: 0;
  background-color: #ffffff;
  z-index: 10;
}
/* 2. 消息列表滚动容器 - 去掉默认padding，避免滚动区域错位 */
.message-list-scroll {
  padding: 0;
  /* 兼容不同浏览器的滚动条样式 */
  scrollbar-width: thin;
  scrollbar-color: #dcdfe6 #f5f7fa;
}
/* 3. 底部按钮栏固定 - 样式强化 */
.message-footer-fixed {
  position: sticky;
  bottom: 0;
  background-color: #ffffff;
  z-index: 10;
}
/* 4. 修复el-dropdown-item的默认样式，避免滚动时出现多余边框 */
::v-deep .el-dropdown-item {
  padding: 0 !important;
  margin: 0 !important;
  border: none !important;
}
/* 5. 滚动容器的滚动条样式优化（可选） */
.message-list-scroll::-webkit-scrollbar {
  width: 6px;
}
.message-list-scroll::-webkit-scrollbar-track {
  background: #f5f7fa;
  border-radius: 3px;
}
.message-list-scroll::-webkit-scrollbar-thumb {
  background: #dcdfe6;
  border-radius: 3px;
}
.message-list-scroll::-webkit-scrollbar-thumb:hover {
  background: #c0c4cc;
}
</style>
